var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterpriseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4795 2.32617C12.5412 4.04768 15.1563 5.1278 18.0195 5.26172C18.0868 5.76957 18.123 6.28779 18.123 6.81445C18.123 11.8518 14.9426 16.145 10.4795 17.7998C6.01645 16.1449 2.836 11.8517 2.83594 6.81445C2.83594 6.28784 2.87126 5.76952 2.93848 5.26172C5.80207 5.12804 8.4175 4.04786 10.4795 2.32617ZM14.6064 6.75879C14.0136 6.1662 13.0527 6.16606 12.46 6.75879L9.46094 9.75684L8.49902 8.79492C7.90623 8.20213 6.94534 8.20215 6.35254 8.79492C5.75974 9.38772 5.75974 10.3486 6.35254 10.9414L8.38867 12.9775C8.98149 13.5701 9.94245 13.5702 10.5352 12.9775L14.6064 8.90527C15.1992 8.31248 15.1992 7.35159 14.6064 6.75879Z",
    fill: "#23242A",
    stroke: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseIcon);
export default __webpack_public_path__ + "static/media/enterprise-icon.5a38193b38b52edf835488c1abf3c54b.svg";
export { ForwardRef as ReactComponent };